import React from "react";

const RPE_POSITIVE = [5, 4.5, 4, 3.5, 3, 2.5, 2, 1.5, 1, 0.5, 0];
const RPE_NEGATIVE = [-0.5, -1, -1.5, -2, -2.5, -3, -3.5, -4, -4.5, -5];

const ProgressionInputFieldComponent = ({
  disabled,
  step,
  placeholder,
  name,
  onInput,
  isRpe,
  progressions = {},
  unchecked,
}) => {
  return (
    <span
      className={`${disabled ? "disabled" : ""} ${
        unchecked ? " unchecked" : ""
      }`}
    >
      <span className={`plus-icon`}>+</span>
      {!isRpe ? (
        <input
          type="number"
          step={step}
          placeholder={placeholder}
          name={name}
          onInput={onInput}
          defaultValue={progressions[name]}
          disabled={disabled || unchecked}
        />
      ) : (
        <select
          name={name}
          value={progressions[name] || 0}
          onChange={onInput}
          disabled={disabled || unchecked}
        >
          {RPE_POSITIVE.concat(RPE_NEGATIVE).map((i) => (
            <option key={`rpe${i}`} value={i}>
              {i}
            </option>
          ))}
        </select>
      )}
    </span>
  );
};

export default ProgressionInputFieldComponent;
